/* Enso Lighting - best-of buying guides (23 Oct 2026).
   1. Add to bag buttons (data-bg-add) post to /cart/add.js. The theme's own fetch wrapper (layout) sees the
      cart/add call, re-renders the bag drawer and opens it, so nothing else is needed here.
   2. Quick look: links with data-quick-look open the product in a side panel (a sheet on a phone) instead of
      leaving the guide. The panel body is sections/enso-guide-quick-look.liquid, fetched with the Section
      Rendering API. Back closes it. Ctrl/Cmd/middle click and any fetch failure fall through to the product page. */
(function () {
  'use strict';
  const SECTION = 'enso-guide-quick-look';
  const cache = new Map();
  let dialog = null, wrap = null, opener = null, pushed = false, token = 0;

  const money = pence => new Intl.NumberFormat('en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(pence / 100);
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function addToBag(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(r => { if (!r.ok) return r.json().then(e => { throw e; }); return r.json(); });
  }

  // Buy bar buttons on the guide itself
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-bg-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    const label = btn.querySelector('[data-bg-label]'), was = label ? label.textContent : '';
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
    addToBag(btn.dataset.bgAdd, 1)
      .then(() => { btn.classList.add('is-added'); if (label) label.textContent = 'Added to bag'; })
      .catch(err => { if (label) label.textContent = (err && err.description) || 'Could not add'; })
      .finally(() => {
        btn.removeAttribute('aria-busy');
        setTimeout(() => { btn.disabled = false; btn.classList.remove('is-added'); if (label) label.textContent = was; }, 2200);
      });
  });

  // Quick look
  const sectionURL = url => { const u = new URL(url, document.baseURI); u.search = ''; u.hash = ''; u.searchParams.set('section_id', SECTION); return u.toString(); };
  function load(url) {
    const key = sectionURL(url);
    if (!cache.has(key)) {
      cache.set(key, fetch(key, { headers: { Accept: 'text/html' } })
        .then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .catch(err => { cache.delete(key); throw err; }));
    }
    return cache.get(key);
  }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'ql-panel';
    dialog.setAttribute('aria-labelledby', 'ql-name');
    dialog.innerHTML = "<div class='ql-wrap'></div>";
    wrap = dialog.firstElementChild;
    document.body.appendChild(dialog);
    dialog.addEventListener('cancel', e => { e.preventDefault(); close(); });
    let backdropDown = false;
    dialog.addEventListener('pointerdown', e => { backdropDown = e.target === dialog; });
    dialog.addEventListener('click', e => {
      if (e.target === dialog && backdropDown) { close(); backdropDown = false; return; }
      backdropDown = false;
      const t = e.target.closest('button'); if (!t) return;
      if (t.matches('[data-ql-close]')) close();
      else if (t.dataset.qlGo != null) goTo(Number(t.dataset.qlGo));
      else if (t.dataset.qlQty) setQty(qty() + Number(t.dataset.qlQty));
      else if (t.dataset.qlAdd) add(t);
    });
    dialog.addEventListener('change', e => { if (e.target.matches('[data-ql-qty-input]')) setQty(qty()); });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ql-lock');
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
  }

  function loading(name) {
    wrap.innerHTML = `<div class='ql'><header class='ql-head'><div class='ql-head-text'><h2 class='ql-name' id='ql-name'>${esc(name || '')}</h2></div><button type='button' class='ql-close' data-ql-close aria-label='Close'>✕</button></header><div class='ql-loading' role='status'>Loading…</div></div>`;
  }

  function render(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const ql = doc.querySelector('.ql');
    if (!ql) throw new Error('No quick look in the response');
    wrap.replaceChildren(document.importNode(ql, true));
    const track = wrap.querySelector('.ql-track');
    if (track) {
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(markThumb); }, { passive: true });
    }
  }
  function markThumb() {
    const track = wrap.querySelector('.ql-track'); if (!track) return;
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    wrap.querySelectorAll('[data-ql-go]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.qlGo) === i)));
  }
  function goTo(i) {
    const track = wrap.querySelector('.ql-track'); const slide = track && track.children[i]; if (!slide) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    wrap.querySelectorAll('[data-ql-go]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.qlGo) === i)));
  }

  const qtyInput = () => wrap.querySelector('[data-ql-qty-input]');
  function qty() { const n = parseInt(qtyInput() ? qtyInput().value : '1', 10); return Number.isFinite(n) ? n : 1; }
  function setQty(n) {
    n = Math.min(99, Math.max(1, n || 1));
    const input = qtyInput(); if (input) input.value = n;
    const btn = wrap.querySelector('[data-ql-add]'); const total = wrap.querySelector('[data-ql-total]');
    if (btn && total) total.textContent = money(Number(btn.dataset.qlPrice) * n);
  }

  async function open(url, link) {
    if (!dialog) build();
    opener = link || document.activeElement;
    const mine = ++token;
    if (!dialog.open) {
      loading(link && link.dataset.qlName);
      document.documentElement.classList.add('ql-lock');
      dialog.showModal();
      if (!pushed) { history.pushState({ ensoQuickLook: true }, ''); pushed = true; }
    }
    try {
      const html = await load(url);
      if (mine !== token || !dialog.open) return;
      render(html);
      dialog.querySelector('.ql-close').focus({ preventScroll: true });
    } catch (err) {
      if (mine === token) { close(); location.href = url; }
    }
  }

  async function add(btn) {
    const label = btn.querySelector('[data-ql-add-label]'), was = label ? label.textContent : '';
    btn.disabled = true; if (label) label.textContent = 'Adding…';
    try {
      const n = qty();
      close();
      await addToBag(btn.dataset.qlAdd, n);
    } catch (err) {
      btn.disabled = false; if (label) label.textContent = was;
    }
  }

  function close() {
    if (!dialog || !dialog.open) return;
    token++;
    dialog.close();
    if (pushed) { pushed = false; if (history.state && history.state.ensoQuickLook) history.back(); }
  }

  window.addEventListener('popstate', () => { if (pushed) { pushed = false; if (dialog && dialog.open) { token++; dialog.close(); } } });
  if (history.state && history.state.ensoQuickLook) history.replaceState(null, '');

  document.addEventListener('click', e => {
    const a = e.target.closest('a[data-quick-look]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    open(a.href, a);
  });
  const warm = e => { const a = e.target.closest && e.target.closest('a[data-quick-look]'); if (a) load(a.href).catch(() => {}); };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);
})();